module.exports = __webpack_public_path__ + "static/media/bazing-icon.3d9edaf9.png";